export default __webpack_public_path__ + "static/media/Repeat_Grid.582bc39b.png";